<mat-tab-group class="mat-tab-group" [selectedIndex]="tabIndex" (selectedIndexChange)="onTabChanged($event)">
    <!-- Events-->
    <mat-tab label="Events" class="table-container">
        <div class="table-container">
            <table mat-table [dataSource]="eventsData" matSort class="mat-elevation-z8">

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <div class="header-content">
                            <mat-icon class="header-icon">calendar_today</mat-icon>
                            Date
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row" class="date-col">
                        <div *ngIf="row.endDate">
                            <p><span class="def">{{'events.start' | translate}}:</span> {{row.startDateText}}</p>
                            <p><span class="def">{{'events.end' | translate}}:</span> {{row.endDateText}}</p>
                            <p><span class="def">{{'events.duration' | translate}}:</span> {{row.duration}}</p>
                        </div>
                        <div *ngIf="!row.endDate">{{row.date}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="worker-column-width">
                        <div class="header-content">
                            <mat-icon class="header-icon">title</mat-icon>
                            Title
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row" class="worker-column-width">
                        <h4 *ngIf="!row.editable"><a (click)="row.editable = true">{{row.title}}</a></h4>

                        <mat-form-field appearance="fill" *ngIf="row.editable">
                            <mat-label>{{'form.name' | translate}}</mat-label>
                            <input matInput placeholder="{{'form.name' | translate}}" [(ngModel)]="row.title"
                                (change)="onEventChanged(row)">
                        </mat-form-field>
                        <a *ngFor="let attachment of row.attachments; let index = index"
                            (click)="onImageClick(index, row.attachments)" title="{{attachment.name}}"><img
                                [src]="attachment.thumbnail" class="attachment-thumbnail"
                                style="margin:2px;width:80px;" />
                        </a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="resources">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="header-content">
                            <mat-icon class="header-icon">devices_other</mat-icon>
                            Resources
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row">
                        <div *ngIf="row.units && row.units.length && !row.unitName">
                            <div class="chip-list">
                                <lib-chip *ngFor="let unit of row.units" text="{{unit.name}}" color="primary"
                                    icon="devices_other">
                                </lib-chip>
                            </div>
                        </div>

                        <div *ngIf="row.unitName">
                            <div class="chip-list">
                                <lib-chip color="primary" icon="devices_other" text="{{row.unitName}}">
                                </lib-chip>
                            </div>
                        </div>

                        <div *ngIf="row.trackers && row.trackers.length && !row.trackerName">
                            <div class="chip-list">
                                <lib-chip *ngFor="let tracker of row.trackers" color="muted" icon="track_changes"
                                    text="{{tracker.name}}">
                                </lib-chip>
                            </div>
                        </div>

                        <div *ngIf="row.trackerName">
                            <div class="chip-list">
                                <lib-chip color="secondary" icon="track_changes" text="{{row.trackerName}}">
                                </lib-chip>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="zones">
                    <th mat-header-cell *matHeaderCellDef class="worker-column-width">
                        <div class="header-content">
                            <mat-icon class="header-icon">place</mat-icon>
                            Zones
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row">
                        <div *ngIf="row.zones" class="chip-list">
                            <lib-chip color="primary" *ngFor="let zone of row.zones" text="{{zone.name}}"
                                color="outline">
                            </lib-chip>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="header-content">
                            <mat-icon class="header-icon">edit</mat-icon>
                            Actions
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row">

                        <ng-container *ngIf="row.startDate && row.endDate">
                            <button mat-button color="primary" [matMenuTriggerFor]="replays">{{'workflows.replay' |
                                translate}}</button>
                            <mat-menu #replays="matMenu">
                                <button mat-flat-button (click)="replayEvent(row,'dashboard')">
                                    {{'dashboard.title' | translate}}
                                </button><br>

                                <button mat-flat-button (click)="replayEvent(row,'viewer/maps')">
                                    {{'viewer.maps' | translate}}
                                </button><br>

                                <button mat-flat-button (click)="replayEvent(row,'viewer/forge')">
                                    {{'viewer.forge' | translate}}
                                </button>
                            </mat-menu>
                        </ng-container>
                        <!-- <button mat-button color="primary" (click)="replayEvent(row, 'forge')">
                            Replay 3D
                        </button>
                        <button mat-button color="secondary" (click)="replayEvent(row, 'maps')">
                            Replay Maps
                        </button> -->
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="eventsColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: eventsColumns;"></tr>

                <tr class="mat-row no-data-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="eventsColumns.length">
                        <lib-no-data message="form.search_no_data" description="form.search_no_data_desc"
                            icon="search_off">
                        </lib-no-data>
                    </td>
                </tr>
            </table>

            <mat-paginator #eventPaginator [length]="eventsCount" [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]"
                class="paginator">
            </mat-paginator>

            <div *ngIf="loading" class="table-overlay">
                <app-spinner></app-spinner>
            </div>
        </div>
    </mat-tab>


    <!-- Metrics -->
    <mat-tab label="Metrics" class="table-container">
        <div class="table-container">
            <table mat-table [dataSource]="metricsData" matSort class="mat-elevation-z8">
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="date-col">
                        <div class="header-content">
                            <mat-icon class="header-icon">calendar_today</mat-icon>
                            Date
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row" class="date-col">
                        <div *ngIf="row.endDate" class="date-def">
                            <div class="def">
                                <mat-icon fontIcon="today" matTooltip="{{'events.start' | translate}}"></mat-icon>
                                {{row.startDateText}}
                            </div>

                            <div class="def">
                                <mat-icon fontIcon="event" matTooltip="{{'events.end' | translate}}"></mat-icon>
                                {{row.endDateText}}
                            </div>


                            <div class="def">
                                <mat-icon fontIcon="timer" matTooltip="{{'events.duration' | translate}}"></mat-icon>
                                {{row.duration}}
                            </div>
                        </div>

                        <div *ngIf="!row.endDate">{{row.date}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="name-col">
                        <div class="header-content">
                            <mat-icon class="header-icon">title</mat-icon>
                            {{'datatable.title' | translate}}
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row" class="name-col">
                        <h5 *ngIf="!row.editable"><a (click)="row.editable = true">{{row.title}}</a></h5>

                        <mat-form-field appearance="fill" *ngIf="row.editable">
                            <mat-label>{{'form.name' | translate}}</mat-label>
                            <input matInput placeholder="{{'form.name' | translate}}" [(ngModel)]="row.title"
                                (change)="onEventChanged(row)">
                        </mat-form-field>
                        <div class="pictures-container">
                            <a *ngFor="let attachment of row.attachments; let index = index"
                                (click)="onImageClick(index, row.attachments)" title="{{attachment.name}}"><img
                                    [src]="attachment.thumbnail" class="attachment-thumbnail"
                                    style="margin:2px;width:80px;" /></a>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="resources">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="header-content">
                            <mat-icon class="header-icon">devices_other</mat-icon>
                            {{'datatable.units' | translate}}
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row">
                        <div class="chip-list" *ngIf="row.units">
                            <lib-chip color="primary" *ngFor="let unit of row.units" text="{{unit.name}}"
                                icon="devices_other">
                            </lib-chip>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="payload">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="header-content">
                            <mat-icon class="header-icon">data_usage</mat-icon>
                            Payload
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row">
                        <div class="payload-col" *ngIf="row?.payloadArray?.length">
                            <ng-container
                                *ngTemplateOutlet="payloadItems; context: { items: row.payloadArray | slice:0:5 }">
                            </ng-container>

                            <lib-chip *ngIf="row.payloadArray.length > 5" [text]="'+' + (row.payloadArray.length - 5)"
                                color="outline" icon="more_horiz" [matMenuTriggerFor]="morePayload">
                            </lib-chip>

                            <mat-menu #morePayload="matMenu">
                                <div class="payload-menu">
                                    <ng-container
                                        *ngTemplateOutlet="payloadItems; context: { items: row.payloadArray | slice:5 }">
                                    </ng-container>
                                </div>
                            </mat-menu>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="action-col">
                        <div class="header-content">
                            <mat-icon class="header-icon">edit</mat-icon>
                            Actions
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row" class="action-col">
                        <ng-container *ngIf="row.startDate && row.endDate">
                            <lib-button color="none" textColor="secondary" [matMenuTriggerFor]="replays" icon="launch">
                                {{'workflows.replay' | translate}}
                            </lib-button>

                            <mat-menu #replays="matMenu">
                                <div class="menu-box">
                                    <button mat-menu-item (click)="replayEvent(row,'dashboard')" class="primary">
                                        <mat-icon fontIcon="dashboard"></mat-icon>
                                        {{'dashboard.title' | translate}}
                                    </button>

                                    <button mat-menu-item (click)="replayEvent(row,'viewer/maps')" class="primary">
                                        <mat-icon fontIcon="map"></mat-icon>
                                        {{'viewer.maps' | translate}}
                                    </button>

                                    <button mat-menu-item (click)="replayEvent(row,'viewer/forge')" class="primary">
                                        <mat-icon fontIcon="view_in_ar"></mat-icon>
                                        {{'viewer.forge' | translate}}
                                    </button>
                                </div>
                            </mat-menu>
                        </ng-container>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="metricsColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: metricsColumns;"></tr>

                <tr class="mat-row no-data-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="metricsColumns.length">
                        <lib-no-data message="form.search_no_data" description="form.search_no_data_desc"
                            icon="search_off">
                        </lib-no-data>
                    </td>
                </tr>
            </table>

            <mat-paginator #metricPaginator [length]="metricsCount" [pageSize]="10"
                [pageSizeOptions]="[10, 20, 50, 100]" class="paginator">
            </mat-paginator>

            <div *ngIf="loading" class="table-overlay">
                <app-spinner></app-spinner>
            </div>
        </div>
    </mat-tab>

    <!-- Attachments -->
    <mat-tab label="Attachments">
        <div class="table-container">
            <table mat-table [dataSource]="attachmentsData" matSort class="mat-elevation-z8">
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="date-col">
                        <div class="header-content">
                            <mat-icon class="header-icon">calendar_today</mat-icon>
                            Date
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row" class="date-def">
                        <div class="def">
                            <mat-icon fontIcon="today" matTooltip="{{'events.start' | translate}}"></mat-icon>
                            {{row.date}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="picture">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <div class="header-content">
                            <mat-icon class="header-icon">image</mat-icon>
                            Picture
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row">
                        <div class="pictures-container">
                            <a (click)="onImageClick(0, [row])" title="{{row.name}}">
                                <img [src]="row.thumbnail" class="attachment-thumbnail"
                                    style="margin:2px;width:100px;" />
                            </a>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="name-col">
                        <div class="header-content">
                            <mat-icon class="header-icon">title</mat-icon>
                            Title
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row" class="name-col">
                        <h5>{{row.name}}</h5>

                        <div class="chip-list">
                            <lib-chip *ngIf="row.unit" color="primary" text="{{row.unit.name}}" icon="devices_other">
                            </lib-chip>

                            <lib-chip *ngIf="row.tracker" color="secondary" text="{{row.tracker.name}}"
                                icon="track_changes">
                            </lib-chip>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="predictions">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="header-content">
                            <mat-icon class="header-icon">insights</mat-icon>
                            Predictions
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row">
                        <div *ngFor="let item of row.predictionArray">
                            <span class="def">{{item.tag}}:</span>
                            {{item.probability}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="action-col">
                        <div class="header-content">
                            <mat-icon class="header-icon">edit</mat-icon>
                            Actions
                        </div>
                    </th>

                    <td mat-cell *matCellDef="let row" class="action-col">
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="attachmentsColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: attachmentsColumns;"></tr>

                <tr class="mat-row no-data-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="attachmentsColumns.length">
                        <lib-no-data message="form.search_no_data" description="form.search_no_data_desc"
                            icon="search_off">
                        </lib-no-data>
                    </td>
                </tr>
            </table>

            <mat-paginator #attachmentPaginator [length]="attachmentsCount" [pageSize]="10"
                [pageSizeOptions]="[10, 20, 50, 100]" class="paginator">
            </mat-paginator>

            <div *ngIf="loading" class="table-overlay">
                <app-spinner></app-spinner>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>

<!-- Templates -->
<ng-template #payloadItems let-items="items">
    <ng-container *ngFor="let item of items; let i = index">
        <lib-chip *ngIf="isObject(item.value)" [text]="item.key" color="outline" icon="more_horiz"
            [matMenuTriggerFor]="detailMenu" (click)="$event.stopPropagation()">
        </lib-chip>

        <mat-menu #detailMenu="matMenu">
            <div class="payload-menu">
                <lib-chip *ngFor="let detail of getObjectDetails(item.value); let j = index"
                    [text]="detail.key + ' : ' + detail.value" [color]="getPayloadItemConfig(detail.key).color"
                    [style.color]="'white !important'" [icon]="getPayloadItemConfig(detail.key).icon"
                    [svgIcon]="getPayloadItemConfig(detail.key).svgIcon">
                </lib-chip>
            </div>
        </mat-menu>

        <lib-chip *ngIf="!isObject(item.value)" [text]="(item?.key || '') + ' : ' + (item?.value || '')"
            [color]="item?.key === 'color' ? '' : getPayloadItemConfig(item?.key).color"
            [hexColor]="item?.key === 'color' ? item.value : ''" [style.color]="'white !important'"
            [icon]="getPayloadItemConfig(item?.key).icon" [svgIcon]="getPayloadItemConfig(item?.key).svgIcon">
        </lib-chip>
    </ng-container>
</ng-template>